import type { ThunkAction, UnknownAction } from "@reduxjs/toolkit";

import { SetTenantDefaultCarrierMutation } from "~/gql/mutations/carrier.generated";
import { GetTenantCarrierConfigQuery } from "~/gql/queries/carrier.generated";
import addSavedDefaultCarrier from "~/helpers/addSavedDefaultCarrier";

const importCarriersPaginatedApiLazilyToBreakCycle = async () =>
	(await import("~/services/endpoints/carriersPaginatedApi")).default;

type CycleFreeLifecycleDispatch = <ReturnValue, State>(
	thunkAction: ThunkAction<ReturnValue, State, unknown, UnknownAction>
) => ReturnValue;

interface SetTenantDefaultCarrierLifecycle {
	dispatch: CycleFreeLifecycleDispatch;
	queryFulfilled: Promise<{ data: SetTenantDefaultCarrierMutation }>;
}

export const carrierEndpoints = {
	GetTenantCarrierConfig: {
		providesTags: ["TenantCarrierConfig"] as AddTagTypes,
		transformResponse: (res: GetTenantCarrierConfigQuery) => res
	},
	SetTenantDefaultCarrier: {
		invalidatesTags: ["TenantCarrierConfig"] as AddTagTypes,
		async onQueryStarted(_arg: unknown, { dispatch, queryFulfilled }: SetTenantDefaultCarrierLifecycle) {
			const carriersPaginatedApi = await importCarriersPaginatedApiLazilyToBreakCycle();
			const fulfilled = await queryFulfilled.catch(() => null);
			if (!fulfilled) return;
			dispatch(
				carriersPaginatedApi.util.updateQueryData("GetCarriersPaginated", {}, (draft) =>
					addSavedDefaultCarrier(fulfilled.data.setTenantDefaultCarrier, draft)
				)
			);
		},
		transformResponse: (res: SetTenantDefaultCarrierMutation) => res
	}
};
